const NOOP = () => {}

export default NOOP
